import {Injectable} from '@angular/core';
import {NgEventBus} from "ng-event-bus";
import {MetaData} from "ng-event-bus/lib/meta-data";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EventBusService {

  constructor(private eventBus: NgEventBus) {
  }

  publish(key: string, value: any) {
    this.eventBus.cast(key, value)
  }

  on(key: string): Observable<MetaData> {
    return this.eventBus.on(key);
  }

}

